const index = () => import(/* webpackChunkName: "incentive" */ './Index');
const history = () => import(/* webpackChunkName: "incentive" */ './history');



export default {
  routes: [
    //项目
    {
      path: '/smes/index',
      name: 'smes_specialIndex',
      component: index
    },
    {
      path: '/smes/history',
      name: 'smes_specialHistory',
      component: history
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/smes/index/router.js